import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Content from './Content.js';
import About from './About.js';
import Contact from './Contact.js';
import My404Component from './My404Component.js';


function Routes() {
  return (
      <BrowserRouter>
        <Switch>
          <Route exact path = "/" component = {Content} />
          <Route path = "/about" component = {About} />
          <Route path = "/contact" component = {Contact} />
          <Route path='*' exact={true} component={My404Component} />

        </Switch>
      </BrowserRouter>
  );
}

export default Routes;